<cv-generic-identifier-list
	[listTitle]="'Product Identifier'"
	[labelAddButton]="'Add Product Identifier'"
	[identifierLabel]="'Generic Integration Product Name'"
	[secondFieldLabel]="'Id'"
	[showSecondField]="true"
	[disableSecondFieldInEdit]="true"
	[integrationName]="integrationName"
	[service]="productService"
	[broadcastEvent]="ADD_EDIT_PRODUCT_IDENTIFIER"
	[getListFn]="getListFn"
	[deleteFn]="deleteFn"
	[getSecondFieldValue]="getSecondFieldValue"
	[modelFactory]="modelFactory"
>
</cv-generic-identifier-list>
